import { createElement, ReactNode } from 'react';
import { useStyles } from '@team-griffin/stylr';
import { useTheme, Colorway } from '@uds/theme-utils';
import { content } from '@ux/type-size';
import { getBodyColor } from 'presentation/utils/colorway';

interface OuterProps {
  colorway: Colorway;
  children?: ReactNode;
}

const useStylesheet = ({ colorway }: { colorway: Colorway }) => {
  const { theme } = useTheme();
  const { typography } = theme;

  return useStyles({
    default: {
      root: {
        color: getBodyColor(theme, colorway),
        ...content(),
        fontFamily: typography.content,
      },
    },
  });
};

const PureParagraph = ({ colorway, children }: OuterProps) => {
  const { styles } = useStylesheet({ colorway });

  return createElement('p', { style: styles.root }, children);
};

PureParagraph.displayName = 'LegalDocumentParagraph';

export default PureParagraph;
